<template>
    <div class="login d-flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
        <form class="d-flex flex-column align-items-center justify-content-center w-100"  @submit.prevent="login">
            <div class="login_card" style="border-radius: 56px; padding: 0.3rem; background: linear-gradient(180deg, var(--primary-color) 10%, rgba(33, 150, 243, 0) 30%)">
                <div class="w-full surface-card py-8 px-5 sm:px-8" style="border-radius: 53px">
                    <div class="text-center mb-5">
                        <img src="@/assets/images/logo_navbar.png" alt="Image" class="logo_navbar my-3" />
                        <div class="text-900 text-3xl font-medium mb-3">مرحبا بك</div>
                        <span class="text-600 font-medium">برجاء تسجيل الدخول</span>
                    </div>

                    <div class="d-flex flex-column">
                        <label for="email1" class="block text-900 text-xl font-medium mb-2">المستخدم</label>
                        <InputText id="email1" type="text" placeholder="المستخدم" class="w-100 mb-4" style="padding: 1rem" v-model="phone" />

                        <label for="password1" class="block text-900 font-medium text-xl mb-2">كلمة المرور</label>
                        <Password id="password1" v-model="password" placeholder="كلمة المرور" :feedback="false" class="w-100 mb-4" inputClass="w-full" :inputStyle="{ padding: '1rem', width: '100%' }"></Password>

                    </div>
                    <button type="submit" class="btn loginButton">تسجيل الدخول</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import Button from 'primevue/button';
import Checkbox from 'primevue/checkbox';
import Swal from 'sweetalert2';

export default {
    name: "login-auth",
    data() {
        return {
            phone: "",
            password: "",
        }
    },
    components: {
        InputText,
        Password,
        Button,
        Checkbox
    },
    methods: {
        async login() {
            const formData = new FormData();
            formData.append('phone', this.phone);
            formData.append('password', this.password);
            let response = await this.$store.dispatch("Login", formData);
            // console.log(this.phone.replace(/\s+/g, ''));
            if (this.phone === "" || this.password === "") {
                Swal.fire({
                    position: "center",
                    icon: "error",
                    title: "برجاء التحقق من كل البيانات",
                });
                this.disableButton = false;
            }
            else {
                try {
                    if (response.data.status == true) {
                        Swal.fire({
                            position: "center",
                            icon: "success",
                            title: response.data.message,
                        });
                        this.phone= "",
                        this.password = ""
                        this.$router.go('/');
                    }
                    else if(response.data.status == false){
                        Swal.fire({
                            position: "center",
                            icon: "error",
                            title: response.data.message,
                        });
                    }
                }catch (err) {
                    // console.log(err.response)
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: err.response.data.message,
                    });
                }
            }
        },
    }
}
</script>